import { useQuery } from "@tanstack/react-query";
import type { DietMenuPreview } from "@/features/diets/types/diet-menu-preview.type";
import { GET } from "@/lib/methods";

type UseDietMenuPreviewParams = {
  dietId: string;
  date: string;
  caloricityId: string;
  enabled?: boolean;
};

export const useDietMenuPreview = ({
  dietId,
  date,
  caloricityId,
  enabled = true,
}: UseDietMenuPreviewParams) => {
  return useQuery({
    queryKey: ["menu-preview-2", dietId, date, caloricityId],
    queryFn: async () => {
      return await GET<DietMenuPreview>({
        url: `${process.env.NEXT_PUBLIC_FOOAPP_URL}/menu-preview-2/${dietId}/${date}/${caloricityId}`,
      });
    },
    staleTime: Infinity,
    retry: 1,
    enabled,
  });
};
